import { FileOpener } from "@capacitor-community/file-opener";
import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";

export class CapacitorUtils {
    static readonly isApp = Capacitor.getPlatform() !== "web";

    static async writeAndOpenFile(data: Blob, fileName: string) {
        var reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = async function () {
            var base64data = reader.result;
            try {
                const result = await Filesystem.writeFile({
                    path: fileName,
                    data: <string>base64data,
                    directory: Directory.Data,
                    recursive: true,
                });
                // Open file
                await FileOpener.open({
                    filePath: result.uri,
                    contentType: data.type,
                    openWithDefault: true,
                });
                // let fileOpener: FileOpener = new FileOpener();
                // fileOpener
                //     .open(result.uri, data.type)
                //     .then(() => console.log("File is opened"))
                //     .catch((e) => console.log("Error opening file", e));

                // console.log("Wrote file", result.uri);
            } catch (e) {
                console.error("Unable to write file", e);
            }
        };
    }
}
